export default function Insert(medicamentos, dados) {

  medicamentos.map((medicamento) => {
    dados(prevState => ([
      ...prevState,
      {
        substancia: medicamento.substancia,
        nomeMedicamento: medicamento.medicamento,
        apresentacao: medicamento.apresentacao,
        duracaoTratamento: medicamento.duracaoTratamento + '-' + medicamento.periodoTratamento,
        posologia: medicamento.posologia,
        observacao: medicamento.observacao,
        idMedicamento: medicamento.idMedicamento
      }
    ]))
  })


}